import type { ReactNode } from 'react'
import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import type { DraggableBounds, DraggableData, DraggableEvent } from 'react-draggable'
import Draggable from 'react-draggable'
import pop_close from '@/assets/images/modal/pop-close.svg'

import './index.less'

const prefix = 'modal'
interface IModal {
  visible: boolean
  headerTitle: string
  styles?: any
  children?: string | ReactNode
  handleClose?: () => void
  isNotDragWithParent?: string
}
const Modal: React.FC<IModal> = (props) => {
  const { visible, styles, handleClose, children, headerTitle = '', isNotDragWithParent = 'isNotDragWithParent' } = props
  useEffect(() => {
    const { clientHeight } = window?.document?.documentElement
    if (visible) {
      setMaxHeight(clientHeight - 220)
    }
  }, [visible])
  const draggableRef = useRef() as any
  const [bound, setBound] = useState<DraggableBounds>({
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  })
  const [maxHeight, setMaxHeight] = useState<number>(0)
  const handleStart = (e: DraggableEvent, draggableData: DraggableData) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = (draggableRef?.current as any)?.getBoundingClientRect()
    const resizeableSpaceWidth = 5
    setBound({
      left: -targetRect?.left + draggableData?.x,
      right: clientWidth - (targetRect?.right - draggableData?.x) - resizeableSpaceWidth,
      top: -targetRect?.top + draggableData?.y,
      bottom: clientHeight - (targetRect?.bottom - draggableData?.y),
    })
  }

  return visible
    ? ReactDOM.createPortal(
        <Draggable onStart={handleStart} bounds={bound}
        // bounds="parent"
         axis="both" handle={isNotDragWithParent ? `.${isNotDragWithParent}` : '.modelhandler'}>
          <div className={`${prefix}`} style={styles} ref={draggableRef} >
            <div className={`${prefix}-move-top ${isNotDragWithParent}`}></div>
            <div className={`${prefix}-move-bottom ${isNotDragWithParent}`}></div>
            {/* <div className={`${prefix}-move-left ${isNotDragWithParent}`}></div>
            <div className={`${prefix}-move-right ${isNotDragWithParent}`}></div> */}
            <div className={`${prefix}-header`}>
              <div>{headerTitle}</div>
              <img className="btn-pop-close" onClick={handleClose} src={pop_close} alt="close" style={{ zIndex: '10' }} />
            </div>
            <div style={{
              maxHeight,
            }} className={`${prefix}-content`}>{children}</div>
          </div>
        </Draggable>,
        document.body,
    )
    : null
}

export default Modal
